module.exports = __webpack_public_path__ + "img/vip-banner-advanced.773b1a4f.png";